import { configureStore } from "@reduxjs/toolkit";
import darkModeReducer from "./darkModeSlice";
import colorSchemeReducer from "./colorSchemeSlice";
import menuReducer from "./menuSlice";
import themeReducer from "./themeSlice";
import authReducer from "./authSlice";
import shopReducer from "./shopSlice";
import notificationReducer from "./notificationSlice";

export const store = configureStore({
    reducer: {
        darkMode: darkModeReducer,
        colorScheme: colorSchemeReducer,
        menu: menuReducer,
        theme: themeReducer,
        auth: authReducer,
        shop: shopReducer,
        notification: notificationReducer,
    },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;